// Normalizes a string for accent-insensitive, case-insensitive search.
// Strips diacritics (e.g. "Café" -> "cafe") so a plain ASCII query matches
// accented names and vice-versa. Client-side only — does not affect API calls.
export const normalizeForSearch = (value) => {
  if (!value) return '';
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
};

export const formatDate = (isoDateString) => {
  if (!isoDateString) return '';

  const date = new Date(isoDateString);
  const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  // return `${year}-${month}-${day}`;
  return `${day}-${month}-${year}`;
};

export const formatCurrency = (amount, currency = 'EUR') => {
  // eslint-disable-next-line no-undef
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
